import React from "react";

const BlogCard = ({
  section,
  title,
  description,
  image,
  link,
  author,
  date,
}) => {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="w-96 flex flex-col items-center text-black no-underline"
    >
      <div className="p-4 transition-all duration-500 cursor-pointer rounded-xl hover:bg-gray-100">
        {section && (
          <p className="text-m text-gray-500 font-semibold mb-5">{section}</p>
        )}
        <img
          src={image}
          alt={title}
          className="w-full rounded-2xl mb-4 object-cover"
        />
        <h4 className="mt-4 text-2xl font-semibold">{title}</h4>
        {description && (
          <p className="mt-2 text-md text-gray-600">{description}</p>
        )}
        {author && date && (
          <p className="mt-2 text-sm text-gray-500">
            {author} | {date}
          </p>
        )}
        {!author && date && (
          <p className="mt-2 text-sm text-gray-500">{date}</p>
        )}
      </div>
    </a>
  );
};

export default BlogCard;
